import { useEffect, useState } from 'react';
import defaultAvatar from '../assets/default-avatar.png';
import NavIcon from './navIcons';
import MpaLogo from '../components/MpaLogo';
import './Header.css';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export default function Header({ sidebarOpen, setSidebarOpen }) {
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        const user = localStorage.getItem('user');
        if (user) {
            setUserData(JSON.parse(user));
        }

        const handleStorageChange = () => {
            const user = localStorage.getItem('user');
            if (user) {
                setUserData(JSON.parse(user));
            }
        };

        window.addEventListener('userProfileUpdated', handleStorageChange);
        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('userProfileUpdated', handleStorageChange);
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    const username = userData?.username || 'Guest';
    const userStatus = userData?.status || 'Active';
    const defaultAvatarFallback = defaultAvatar;
    const avatarUrl = userData?.avatar
        ? `${API_BASE.replace('/api', '')}/uploads/avatars/${userData.avatar}`
        : defaultAvatarFallback;

    return (
        <nav className="header-navbar navbar-expand-md navbar navbar-with-menu fixed-top navbar-light navbar-border">
                <div className="navbar-wrapper">
                    <div className="navbar-header">
                        <ul className="nav navbar-nav flex-row align-items-center">
                            <li className="nav-item mobile-menu d-lg-none mr-auto">
                                <button 
                                    type="button"
                                    className="nav-link nav-menu-main menu-toggle btn border-0 bg-transparent p-2"
                                    onClick={() => setSidebarOpen && setSidebarOpen(!sidebarOpen)}
                                    style={{ minHeight: '44px', minWidth: '44px' }}
                                    aria-label="Toggle menu"
                                >
                                    <NavIcon name="icon-menu" className="header-nav-icon header-nav-icon--lg" />
                                </button>
                            </li>
                            <li className="nav-item">
                                <a className="navbar-brand d-flex align-items-center" href="/">
                                    <MpaLogo size={36} />
                                </a>
                            </li>
                            <li className="nav-item d-md-none">
                                <a className="nav-link open-navbar-container p-2" data-toggle="collapse" data-target="#navbar-mobile" href="/">
                                    <i className="fa fa-ellipsis-v" />
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="navbar-container content">
                        <div className="navbar-collapse show" id="navbar-mobile">
                            <ul className="nav navbar-nav navbar-nav--left">
                                <li className="nav-item d-none d-lg-block">
                                    <button 
                                        type="button"
                                        className="nav-link nav-menu-main menu-toggle btn border-0 bg-transparent p-2"
                                        onClick={() => setSidebarOpen && setSidebarOpen(!sidebarOpen)}
                                        aria-label="Toggle menu"
                                    >
                                        <NavIcon name="icon-menu" className="header-nav-icon" />
                                    </button>
                                </li>
                            </ul>
                            <ul className="nav navbar-nav navbar-nav--right">
                                <li className="dropdown dropdown-user nav-item">
                                    <a
                                        className="dropdown-toggle nav-link dropdown-user-link d-flex align-items-center"
                                        href="/"
                                        data-bs-toggle="dropdown"
                                        role="button"
                                        aria-expanded="false"
                                    >
                                        <div className={`avatar me-2 ${userStatus === 'Active' ? 'avatar-online' : 'avatar-offline'}`}>
                                            <img src={avatarUrl} alt="avatar" className="rounded-circle" style={{ width: '32px', height: '32px', objectFit: 'cover' }} />
                                            <i />
                                        </div>
                                        <span className="user-name d-none d-sm-inline-block">{username}</span>
                                        {userStatus !== 'Active' && <span className="badge rounded-pill text-bg-danger ms-1">{userStatus}</span>}
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-right">
                                        <a className="dropdown-item d-flex align-items-center gap-2" href="/profile">
                                            <NavIcon name="icon-user" className="header-nav-icon" />
                                            Edit Profile
                                        </a>
                                        <div className="dropdown-divider" />
                                        <a className="dropdown-item d-flex align-items-center gap-2" href="/logout" onClick={(e) => { e.preventDefault(); localStorage.removeItem('token'); localStorage.removeItem('user'); try { sessionStorage.removeItem('reminder_alert_session_start'); } catch {} window.location.replace('/login'); }}>
                                            <NavIcon name="icon-power" className="header-nav-icon" />
                                            Logout
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </nav>
    )
}

